import type { ICriticalReadingData } from './types';

/**
 * localStorage-backed draft for the Nurse-MA critical-reading template, keyed per
 * reading (`idx`). Lets the template repopulate when reopened before the comment is
 * sent, and is cleared once the comment is submitted (see use-comment-column).
 */
export const nurseMaDraftKey = (idx: string | number): string =>
  `nurse-ma-critical-draft-${idx}`;

export const readNurseMaDraft = (
  idx: string | number,
): ICriticalReadingData => {
  try {
    const raw = localStorage.getItem(nurseMaDraftKey(idx));
    return raw ? (JSON.parse(raw) as ICriticalReadingData) : {};
  } catch {
    return {};
  }
};

export const writeNurseMaDraft = (
  idx: string | number,
  values: ICriticalReadingData,
): void => {
  try {
    localStorage.setItem(nurseMaDraftKey(idx), JSON.stringify(values));
  } catch {
    // best-effort — ignore quota / serialization errors.
  }
};
